import enMessages from '../locales/vi_VN.json';
import { enUS } from '@mui/material/locale';

const ViLang = {
  messages: {
    ...enMessages,
  },
  muiLocale: enUS,
  locale: 'vi-VN',
};
export default ViLang;
